/**
* Specials Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Specials Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'specials-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const specials = $( '.specials-cards' );
      if ( specials.length ) {
        specials.each( function( index, element ) {
          const $cards = $( element ).find( '.specials__card' );
          const $moreBtn = $( element ).find( '.specials-cards__btn' );

          const getCardHeight = () => {
            let cardHeight = '390';
            $( element ).css( '--cardMinHeight', `0px` );

            $cards.each( function( index, element ) {
              const elHeight = $( element ).outerHeight();
              if ( elHeight > cardHeight ) {
                cardHeight = elHeight;
              }
            } );

            $( element ).css( '--cardMinHeight', `${cardHeight}px` );
          };

          const resizeDebounce = new app.components.common.Debounce( () => getCardHeight(), 250 );
          $( window ).on( 'resize', () => resizeDebounce.run() );
          getCardHeight();

          if ( $moreBtn.length ) {
            $moreBtn.on( 'click', function( element ) {
              const hiddenCards = $( '.special-cards__wrapper:not(.is-shown)' );

              if ( hiddenCards.length == 1 ) {
                $( this ).addClass( 'hidden' );
              }
              hiddenCards.eq( 0 ).fadeIn();
              hiddenCards.eq( 0 ).addClass( 'is-shown' );
              getCardHeight();
            } );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'specials-cards', COMPONENT );
} )( app );
